// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3sqNs","content":"styles_content__35Tnp","checkbox":"styles_checkbox__SL3NQ","checkboxLabel":"styles_checkboxLabel__3KcrQ"};